import React, { lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import './App.css';
import './css-imports';
import routes from "./routes.json";

export default function App() {
  return (
    <>
    <Router>
      <div>
        <Switch>
          {Object.entries(routes).map(([key, value]) => {
            return value.map(({ path, component, title }) => {
              const Component = lazy(() => import(/* webpackChunkName: "[request]" */ `./components/${component}`));
              return (
                <Route key={path} path={"/"+key+""+path}>
                  <Suspense fallback={<div>Ladataan...</div>}>
                    {typeof title !== 'undefined' ? (
                      <Component title={title} />
                    ) : (
                      <Component />
                    )}
                  </Suspense>
                </Route>
              );
            });
          })}
        </Switch>
      </div>
    </Router>
  </>
  );
}